import React from 'react';

import type { Logo } from 'client-ribbons-design-system/types/logo';

export const IconPaymentPayPal = ({ height = '32', width = '50' }: Logo) => (
  <svg
    data-testid="icon-payment-pay-pal"
    height={height}
    viewBox="0 0 50 32"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>PayPal logo</title>
    <g fill="none" fillRule="evenodd">
      <rect fill="#FFF" height="32" rx="6" width="50" />
      <g fillRule="nonzero">
        <path
          d="m45.447 12.616-1.016 6.462a.206.206 0 0 0 .204.238h1.021c.17 0 .314-.123.34-.29l1.001-6.346a.206.206 0 0 0-.203-.238H45.65a.206.206 0 0 0-.204.174M42.399 17.037a1.321 1.321 0 0 1-1.338 1.132c-.344 0-.619-.11-.796-.32-.175-.207-.24-.503-.185-.832a1.326 1.326 0 0 1 1.328-1.14c.336 0 .61.111.79.323.181.212.253.51.2.837zm1.651-2.306h-1.185a.206.206 0 0 0-.204.174l-.052.332-.083-.12c-.256-.373-.828-.497-1.4-.497-1.308 0-2.427.992-2.645 2.383-.113.694.048 1.358.442 1.82.361.426.877.603 1.492.603 1.055 0 1.64-.678 1.64-.678l-.052.33a.206.206 0 0 0 .204.238h1.067c.169 0 .313-.123.34-.29l.64-4.057a.206.206 0 0 0-.204-.238zM36.939 14.76c-.135.888-.814.888-1.47.888h-.373l.262-1.659a.206.206 0 0 1 .203-.174h.172c.446 0 .868 0 1.086.255.13.152.17.378.12.69zm-.286-2.318H34.18a.344.344 0 0 0-.34.29l-1 6.346a.206.206 0 0 0 .203.238h1.27a.24.24 0 0 0 .238-.203l.283-1.799a.344.344 0 0 1 .34-.29h.783c1.63 0 2.57-.79 2.817-2.353.11-.683.004-1.22-.316-1.597-.352-.413-.976-.632-1.804-.632z"
          fill="#2790C3"
        />
        <path
          d="M32.71 14.731h-1.19a.344.344 0 0 0-.285.15l-1.643 2.42-.696-2.325a.344.344 0 0 0-.33-.245h-1.17a.206.206 0 0 0-.196.273l1.312 3.85-1.234 1.74a.206.206 0 0 0 .169.326h1.19a.344.344 0 0 0 .282-.148l3.961-5.717a.206.206 0 0 0-.17-.324M24.748 17.037a1.321 1.321 0 0 1-1.338 1.132c-.343 0-.618-.11-.795-.32-.176-.207-.241-.503-.186-.832a1.326 1.326 0 0 1 1.328-1.14c.337 0 .61.111.79.323.182.212.253.51.201.837zm1.651-2.306h-1.185a.206.206 0 0 0-.203.174l-.052.332-.083-.12c-.257-.373-.829-.497-1.4-.497-1.31 0-2.427.992-2.645 2.383-.113.694.047 1.358.441 1.82.362.426.878.603 1.492.603 1.056 0 1.641-.678 1.641-.678l-.053.33a.206.206 0 0 0 .204.238h1.067c.17 0 .313-.123.34-.29l.64-4.057a.206.206 0 0 0-.204-.238zM19.288 14.76c-.135.888-.813.888-1.47.888h-.373l.262-1.659a.206.206 0 0 1 .204-.174h.17c.448 0 .87 0 1.087.255.13.152.17.378.12.69zm-.285-2.318h-2.475a.344.344 0 0 0-.34.29l-1 6.346a.206.206 0 0 0 .203.238h1.182c.17 0 .313-.123.34-.29l.27-1.712a.344.344 0 0 1 .34-.29h.782c1.63 0 2.571-.79 2.817-2.353.11-.683.005-1.22-.316-1.597-.352-.413-.975-.632-1.803-.632z"
          fill="#27346A"
        />
      </g>
      <g transform="translate(4 10)">
        <mask fill="#fff" id="b">
          <path d="M0 10.92h45V0H0z" id="a" />
        </mask>
        <path
          d="m4.682 10.47.332-2.11.022-.117a.433.433 0 0 1 .428-.365h.264c.44 0 .845-.047 1.202-.14a3.05 3.05 0 0 0 1.009-.457c.305-.217.56-.498.761-.833.211-.355.367-.781.461-1.268.084-.43.1-.815.047-1.145a1.726 1.726 0 0 0-.398-.882 1.682 1.682 0 0 0-.481-.371l-.005-.003v-.005c.068-.43.065-.787-.007-1.096a1.943 1.943 0 0 0-.45-.85C7.387.286 6.52.009 5.283.009H1.89a.478.478 0 0 0-.471.403L.005 9.373a.282.282 0 0 0 .28.327H2.39l-.002.01-.144.916a.246.246 0 0 0 .243.285h1.766a.416.416 0 0 0 .411-.351l.018-.09"
          fill="#27346A"
          fillRule="nonzero"
          mask="url(#b)"
        />
      </g>
      <g transform="translate(4 10)">
        <mask fill="#fff" id="d">
          <path d="M0 10.92h45V0H0z" id="c" />
        </mask>
        <path
          d="M3.472 2.786a.425.425 0 0 1 .42-.36h2.66c.315 0 .609.022.877.065a3.865 3.865 0 0 1 .536.128c.132.044.255.095.368.155.133-.85-.001-1.427-.46-1.95C7.367.246 6.453 0 5.283 0H1.89a.486.486 0 0 0-.48.41L-.003 9.37a.291.291 0 0 0 .288.337H2.38l1.092-6.922"
          fill="#27346A"
          fillRule="nonzero"
          mask="url(#d)"
        />
      </g>
      <path
        d="M12.333 12.774c-.01.065-.021.131-.035.199-.447 2.298-1.979 3.092-3.934 3.092h-.996a.484.484 0 0 0-.478.41l-.655 4.15a.255.255 0 0 0 .252.295h1.766a.425.425 0 0 0 .42-.359l.017-.09.333-2.11.021-.116a.425.425 0 0 1 .42-.358h.264c1.71 0 3.05-.696 3.442-2.706.163-.84.079-1.54-.354-2.034a1.682 1.682 0 0 0-.483-.373"
        fill="#2790C3"
        fillRule="nonzero"
      />
      <path
        d="M11.865 12.588a3.251 3.251 0 0 0-.436-.097 5.55 5.55 0 0 0-.877-.064h-2.66a.424.424 0 0 0-.42.359l-.566 3.585-.016.104a.484.484 0 0 1 .478-.41h.996c1.955 0 3.487-.794 3.934-3.092.014-.068.025-.134.035-.199a2.405 2.405 0 0 0-.468-.186"
        fill="#1F264F"
        fillRule="nonzero"
      />
      <g stroke="#AEBCC6">
        <rect height="31" rx="6" width="49" x=".5" y=".5" />
      </g>
    </g>
  </svg>
);
